import { Section } from '@blueprintjs/core'
import { SKELETON } from '@blueprintjs/core/lib/esm/common/classes'

export default () =>
    <Section
        title={<span className={SKELETON}>Lorem ipsum</span>}
        subtitle={<span className={SKELETON}>Lorem ipsum dolor sit amet</span>}
        rightElement={<span className={SKELETON}>Lorem</span>}
        collapsible
        collapseProps={{ isOpen: false }}>
    </Section>